export default __webpack_public_path__ + "static/media/Krones.10477653.png";